import htmlImg from "./skills/html-5.svg";
import cssImg from "./skills/css-3.svg";
import sassImg from "./skills/sass.svg";
import bootstrapImg from "./skills/bootstrap-4.svg";
import javascriptImg from "./skills/javascript-4.svg";
import reactImg from "./skills/react.svg";
import rwdImg from "./skills/rwd.png";

import sqlImg from "./skills/mysql.jpg";
import gitImg from "./skills/Git_icon.svg";
import javaImg from "./skills/java.png";
import cppImg from "./skills/cpp.svg";
import npmImg from "./skills/npmlogo.png";
import vueImg from "./skills/vue.png";
import mongoImg from "./skills/mongo.png";
import nodeImg from "./skills/nodejs-icon.svg";
import expressImg from "./skills/express.png";
import ajaxImg from "./skills/ajax-icon-7.jpg";
import typescriptImg from "./skills/typescript.svg";
import restImg from "./skills/rest.png";
import reduxImg from "./skills/logo-redux.png";
import axiosImg from "./skills/axios.jpg";
import joomlaImg from "./skills/joomla.png";
import wordpressImg from "./skills/wordpress.png";
import angularImg from "./skills/angular.png";
import nextjsImg from "./skills/nextjs.png";
import muiImg from "./skills/mui.png";
import nxImg from "./skills/nx.png";

import mongodbImg from './skills/mongodb.png';
import passportImg from './skills/passport.jpg';
import storybookImg from './skills/storybook.png'
import firebaseImg from './skills/firebase.png';
import herokuImg from './skills/heroku.png';
import netlifyImg from './skills/netlify.png';
import contentfullImg from './skills/contentfull.png';
import stripeImg from './skills/stripe.png';
import styledCoponentsImg from './skills/styledcomponents.png';
import i18nImg from './skills/i18n.png';
import rxjsImg from './skills/rxjs.png';
import scssImg from './skills/scss.png';
import webpackImg from './skills/webpack.png';


export const html = htmlImg;
export const css = cssImg;
export const sass = sassImg;
export const bootstrap = bootstrapImg;
export const javascript = javascriptImg;
export const react = reactImg;
export const rwd = rwdImg;
export const sql = sqlImg;
export const git = gitImg;
export const java = javaImg;
export const cpp = cppImg;
export const npm = npmImg;
export const vue = vueImg;
export const mongo = mongoImg;
export const node = nodeImg;
export const express = expressImg;
export const ajax = ajaxImg;
export const typescript = typescriptImg;
export const rest = restImg;
export const redux = reduxImg;
export const axios = axiosImg;
export const joomla = joomlaImg;
export const wordpress = wordpressImg;
export const angular = angularImg;
export const mui = muiImg;
export const nextjs = nextjsImg;
export const nx = nxImg;

export const mongodb = mongodbImg;
export const passport = passportImg;
export const storybook = storybookImg;
export const firebase = firebaseImg;
export const heroku = herokuImg;
export const netlify = netlifyImg;
export const api = restImg;
export const contentfull = contentfullImg;
export const stripe = stripeImg;
export const reactContext = reactImg;
export const styledcomponents = styledCoponentsImg;
export const i18n = i18nImg;
export const rxjs = rxjsImg;
export const scss = scssImg;
export const webpack = webpackImg;
